import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../../../../AppContext";
import { IStudioSelectItemModel } from "../../models/studioSelectItemModel";
import { getDefaultRoutePath } from "../routePaths";

interface IStudioFeatureRoute {
  /** True when the selected studio switched the page's feature off in its settings. */
  isHidden: (studio?: IStudioSelectItemModel) => boolean;
  children: ReactNode;
}

/**
 * Keeps a page the studio switched off in its settings out of reach of a bookmark or a
 * typed address, the same way hiding its sidebar item keeps it out of the menu: the user
 * lands on their default page instead.
 */
export const StudioFeatureRoute = ({ isHidden, children }: IStudioFeatureRoute) => {
  const { selectedStudio, currentUser } = useAppContext();

  if (isHidden(selectedStudio)) {
    return <Navigate to={getDefaultRoutePath(currentUser)} replace />;
  }

  return <>{children}</>;
};
